import React, { Component } from 'react';
import { Grid, Cell } from 'react-flexr';

// import Nouislider from './nouislider';
// Needed, because nouislider calls window directly, and thus fails on the server
const Nouislider = __CLIENT__ ? require('./nouislider').default : null;

class Slider extends Component {
  constructor(props) {
    super(props);

    this.state = {
      values: this.props.defaultStart || this.props.start
    };
  }

  onSlide = values => {
    const { name } = this.props;
    const data = name ? { name, values } : values;

    if (typeof this.props.onSlide === 'function') {
      this.props.onSlide(data);
    } else if (typeof this.props.onChange === 'function') {
      this.props.onChange(data);
    }

    this.setState({ values });
  };

  render() {
    const { headline = [], units, disconnected, ...props } = this.props;
    const placeholderValues = [].concat(this.state.values);

    return (
      <div>
        {headline.length ? (
          <Grid
            style={{
              fontSize: '1.4em',
              lineHeight: '1em',
              whiteSpace: 'nowrap',
              marginBottom: 11
            }}
          >
            {headline.slice(0, 2).map((item, idx) => (
              <Cell key={idx} style={idx === 1 ? { textAlign: 'right' } : ''}>
                {typeof item === 'function'
                  ? item(placeholderValues)
                  : item.replace(/%s/g, () =>
                      Math.round(placeholderValues.shift())
                    )}
              </Cell>
            ))}
          </Grid>
        ) : null}

        <div
          style={{ margin: '0 0.75em' }}
          className={disconnected ? 'noUi-disconnected' : null}
        >
          {__CLIENT__ ? (
            <Nouislider {...props} onSlide={this.onSlide} />
          ) : (
            <span />
          )}

          {units ? (
            <Grid
              style={{
                fontSize: '75%',
                marginTop: '0.75em',
                marginBottom: '11px'
              }}
            >
              <Cell size="1/2">{units[0] || ''}</Cell>
              <Cell size="1/2" className="text-right">
                {units[1] || ''}
              </Cell>
            </Grid>
          ) : null}
        </div>
      </div>
    );
  }
}

export default Slider;
